// extracted by mini-css-extract-plugin
export default {"leftdiv":"Productpage_leftdiv__ZD1+Q","pardiv":"Productpage_pardiv__5uWCR","delbtn":"Productpage_delbtn__4Msk8"};